export default __webpack_public_path__ + "static/media/fundraiseShare.28576970.png";